import { motion } from "framer-motion";
import Overline from "./Overline";
import { reveal, revealStaggered, VIEW_60, VIEW_80 } from "./motion";

const PRINCIPLES = [
  { number: "01", title: "Unbound Geometry", content: "We discard conventional strict grids in favor of spatial depth and organic mathematical resonance." },
  { number: "02", title: "Tactile Digital", content: "Every interaction carries physical inertia, light reflection, and acoustic balance." },
  { number: "03", title: "Hyper-Performance", content: "60FPS WebGL art direction engineered with uncompromising accessibility and elegance." },
];


export const AboutPhilosophy = () => (
  <section data-testid="about-philosophy" className="px-6 py-28 md:px-16 lg:px-24">
    <motion.div variants={reveal} initial="hidden" whileInView="show" viewport={VIEW_80}>
      <Overline>Our Philosophy</Overline>
      <h2 className="font-display max-w-3xl text-3xl font-bold leading-tight text-[#F4F6FB] md:text-5xl">
        Three principles, zero compromise.
      </h2>
    </motion.div>
    <div className="mt-16 grid gap-6 md:grid-cols-3">
      {PRINCIPLES.map((p, i) => (
        <motion.article
          key={p.number}
          data-testid={`about-principle-${p.number}`}
          variants={revealStaggered}
          initial="hidden"
          whileInView="show"
          viewport={VIEW_60}
          custom={i * 0.12}
          className="group relative overflow-hidden rounded-2xl border border-white/10 bg-[#12141C]/55 p-8 backdrop-blur-xl transition-colors duration-500 hover:border-[#8B5CF6]/50 md:p-10"
        >
          <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#8B5CF6]/70 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
          <span className="text-outline font-display block text-5xl font-black leading-none md:text-6xl">
            {p.number}
          </span>
          <h3 className="font-display mt-6 text-lg font-semibold text-[#F4F6FB] md:text-xl">{p.title}</h3>
          <p className="mt-4 text-sm leading-relaxed text-[#F4F6FB]/55">{p.content}</p>
        </motion.article>
      ))}
    </div>
  </section>
);

export default AboutPhilosophy;
